export default __webpack_public_path__ + "img/0c9284de25ce3250b5e88c8f08dfc047.svg";